import { lazy, type ComponentType } from 'react'

export function routePage<T extends Record<string, unknown>>(
  loader: () => Promise<T>,
  name: keyof T,
) {
  return async () => {
    const module = await loader()
    return { Component: module[name] as ComponentType }
  }
}

export function lazyPage<T extends Record<string, unknown>>(
  loader: () => Promise<T>,
  name: keyof T,
) {
  return lazy(async () => {
    const module = await loader()
    return { default: module[name] as ComponentType }
  })
}
